import { Link } from '../../../components/link';
import { t } from 'i18next';

export default function ManageVideosLink(props: any) {
  return (
    <div>
      <Link
        to=""
        className="rio-realm-link slds-m-right--x-small slds-text-body--small"
        onClick={(ev: any) => {
          ev.preventDefault();
          return props.onClick(ev);
        }}
      >
        <span>
          {t('videos:manage-videos-button')}
          <i className="fa-solid fa-video-plus slds-m-left--xx-small" />
        </span>
      </Link>
    </div>
  );
}
